import type { Result } from '@empathyco/x-types'
import { ref } from 'vue'
import { useXService } from './x/use-x-service'

export function useSearchResults(productId: string): any {
  const MAX_RESULTS_PER_CALL = 250
  const MAX_START = 1000

  const loading = ref(false)
  const error = ref<string | null>(null)
  const xService = useXService()

  async function searchProducts(query: string, start: number): Promise<Result[] | undefined> {
    loading.value = true
    try {
      const response = await xService.search({ start, rows: MAX_RESULTS_PER_CALL, query })
      return response.results
    } catch (e) {
      if (e instanceof Error) {
        error.value = e.message
      }
    } finally {
      loading.value = false
    }
  }

  async function getProductFromQuery(query: string, start = 0): Promise<Result | undefined> {
    const results = await searchProducts(query, start)
    const result = results?.find((result: Result) => result.id === productId)
    if (result || (start === MAX_START && !result)) {
      return result
    }

    return getProductFromQuery(query, start + MAX_RESULTS_PER_CALL)
  }

  return {
    searchProducts,
    getProductFromQuery,
    loading,
    error,
  }
}
